import React from "react";
import { brands } from "../mock";

export default function Brands() {
  return (
    <section id="brands" data-testid="brands-section" className="home-section" style={{ scrollMarginTop: 120 }}>
      <div className="container">
        <div className="reveal mx-auto max-w-[820px] text-center">
          <p className="eyebrow centered">Brands we deal in</p>
          <h2 className="mt-3 font-heading font-extrabold leading-[1.08]"
              style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
            Recognized brands for new &amp; pre-owned requirements
          </h2>
          <p className="mt-4 text-[16px]" style={{ color: "var(--muted)" }}>
            Brand names are used for product identification and customer requirements. Kapatia does
            not claim authorized reseller, distributor or service partner status unless separately
            verified and documented.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-3 sm:grid-cols-3 lg:grid-cols-9">
          {brands.map((b, i) => (
            <span key={b.name}
                  className="reveal flex min-h-[100px] flex-col items-center justify-center gap-2.5 rounded-xl border bg-white p-4 transition-all hover:-translate-y-1"
                  style={{ transitionDelay: `${i * 40}ms`, borderColor: "var(--line)", boxShadow: "0 10px 24px rgba(45,106,79,0.07)" }}>
              <img src={b.logo || `https://cdn.simpleicons.org/${b.slug}`} alt={`${b.name} logo`}
                   data-testid={`brand-logo-${b.slug}`}
                   className="h-8 w-[70px] object-contain" loading="lazy"
                   onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = `/assets/icons/brand-${b.slug}.svg`; }} />
              <strong className="font-heading text-[13.5px] font-bold" style={{ color: "var(--green-950)" }}>{b.name}</strong>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
